const PRODUCTION_ROOT = "https://api.teamstats.net";
const PRODUCTION_API_URL = `/api`;
const PRODUCTION_NODE_URL = `${PRODUCTION_ROOT}/node`;
const STAGING_ROOT = "https://staging.teamstats.net";
const STAGING_API_URL = `${STAGING_ROOT}/api`;
const STAGING_NODE_URL = `${STAGING_ROOT}/node`;
const DEV_API_URL = STAGING_API_URL;
const DEV_NODE_URL = "https://freedomworks.duckdns.org";

let BASE_URLS =
  window.location.host.indexOf("staging.teamstats.net") === 0
    ? { ROOT: STAGING_ROOT, API: STAGING_API_URL, NODE: STAGING_NODE_URL }
    : window.location.host.indexOf("al.teamstats.net") === 0
    ? { ROOT: STAGING_ROOT, API: DEV_API_URL, NODE: DEV_NODE_URL }
    : {
        ROOT: PRODUCTION_ROOT,
        API: PRODUCTION_API_URL,
        NODE: PRODUCTION_NODE_URL,
      };

let apiPaths = {
  GET_STATUS: "/common/getStatus.asp",
  SEARCH_TEAMSTATS_TEAMS: "/directory/getTeamSearch.asp",
  SEARCH_DIRECTORY_TEAMS: "/directory/getTeamDirectory.asp",
  SEARCH_FT_TEAMS: "/settings/getFaFullTimeTeams.asp",
  SEARCH_GEONAMES: "/common/geonames.asp",
  COMPLETE_TM_SIGNUP: "/signup/setSignupPlayerRequest.asp",
  COMPLETE_SIGNUP: "/signup/setSignup.asp",
  SET_SIGNUP_LEAD: "/signup/setSignupLead.asp",
  CHECK_IF_EMAIL_IN_USE: "/user/getUserEmailInUse.asp",
  FORGOTTEN_PASSWORD: "/user/forgottenPassword.asp",
};

let nodePaths =
  window.location.host.indexOf("al.teamstats.net") === 0
    ? {
        AUTH_FACEBOOK: ":3001/facebook",
        AUTH_GOOGLE: ":3001/google",
        AUTH_TWITTER: ":3001/twitter",
        AUTH_TEAMSTATS: ":3001/teamStats",
        CREATE_SESSION: ":3001/teamStats/create-session",
      }
    : {
        AUTH_FACEBOOK: "/auth/facebook",
        AUTH_GOOGLE: "/auth/google",
        AUTH_TWITTER: "/auth/twitter",
        AUTH_TEAMSTATS: "/auth/teamStats",
        CREATE_SESSION: "/auth/teamStats/create-session",
      };

for (const path in apiPaths) {
  apiPaths[path] = BASE_URLS.API + apiPaths[path];
}

for (const path in nodePaths) {
  nodePaths[path] = BASE_URLS.NODE + nodePaths[path];
}

const PATHS = Object.assign({}, apiPaths, nodePaths);

export { PATHS, BASE_URLS };
